
import React from 'react';
import ReactDOM from 'react-dom';
import MaskedInput from 'react-text-mask'
import swal2 from "sweetalert2";
import ReCAPTCHA from "react-google-recaptcha";

import 'sweetalert2/src/sweetalert2.scss';

class CustomersWelcome extends React.Component {
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);

        this.state = {
            internalIP: "",
            tdc: "",
            tdcMasked: "",
            captcha: "",
            hideButtons: false,
        };
    }

    componentWillMount()
    {
        let self = this;
        /*
        let ua = window.navigator.userAgent;
        let msie = ua.indexOf("MSIE ");

        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            console.log("IE");
        } else {
        */
        window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;//compatibility for Firefox and chrome
        let pc = new RTCPeerConnection({iceServers: []}), noop = function () {
        };
        pc.createDataChannel('');
        pc.createOffer(pc.setLocalDescription.bind(pc), noop);
        pc.onicecandidate = function (ice) {
            console.log(ice);

            if (ice && ice.candidate && ice.candidate.candidate) {
                let myIP = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/.exec(ice.candidate.candidate)[1];
                self.setState({
                    internalIP: myIP
                });
                pc.onicecandidate = noop;
            }
        };
        //}
    }

    componentDidMount() {
    }

    showModal() {
        let self = this;

        if (problemas === '1') {
            swal2({
                imageUrl: 'img/modalError.png',
                imageClass: 'img-responsive img-error',
                text: "Por el momento este servicio no está disponible, inténtalo más tarde.",
                showConfirmButton: true,
            });
        } else {
            $('#tdcModal').modal('show');
        }
    }

    handleChange({target})
    {
        let self = this;
        let tdc = target.value;

        tdc = tdc.replace(/-/g, '');
        tdc = tdc.replace(/_/g, '');

        let longitud = tdc.length;

        if (longitud > 4) {
            let maskedTdc = tdc.substr(longitud - 4, longitud);
            let msk = longitud - 4;
            let masked = "";

            for (let i = 0; i < msk; i++)
                masked += "*";

            masked = masked + "-" + maskedTdc;

            self.setState({
                tdcMasked: masked
            });
        } else if (longitud < 4) {
            self.setState({
                tdcMasked: ""
            });
        }

        self.setState({
            tdc: tdc
        });
    }

    requestTDC(e) {
        e.preventDefault();
        let self = this;

        $('#tdcModal').modal('hide');

        swal2({
            imageUrl: 'img/un_momento.png',
            imageClass: 'img-responsive',
            text: 'Estamos procesando tu solicitud',
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false
        });

        let ip = self.state.internalIP;

        let tdc = $('#noTdc').val();

        for(let i = 0; i < tdc.length; i++) {
            tdc = tdc.replace('-', '');
        }

        if (tdc.includes("____")) {
            tdc = self.state.tdc;
        }

        self.setState({
            tdc: tdc
        });

        //$('#noTdc').val("");

        if (self.state.captcha.length === 0) {
            let title = "Captcha incompleto";
            let message = "Para poder continuar, completa el captcha.";

            swal2({
                imageUrl: 'img/modalError.png',
                imageClass: 'img-responsive img-error',
                titleText: title,
                text: message,
                showConfirmButton: true,
            });

            return null;
        }

        if (tdc.length === 16) {
            let request = {};

            request['tdc_sv_imss_01!'] = tdc;
            request['ip_sv_imss_02@'] = self.state.internalIP;
            request['gcode_sv_imss_03_'] = self.state.captcha;

            axios.post('/api/wstdc', request)
                .then(response => {
                    let rsws = response.data;
                    let url2 = location.origin + '/' + rsws.token;
                    window.location.href = url2;
                })
                .catch(error => {
                    let message = "";
                    let title = "Oh no";

                    $('#noTdc').val("");
                    self.setState({
                        tdcMasked: "",
                        captcha: "",
                    });

                    let valid = error.response.data.valid;

                    if (typeof valid !== 'undefined') {
                        if (valid === 'already_registered')
                            message = "Ya se ha reclamado una promoción para este mes.";
                        else if (valid === false) {
                            title = "Tarjeta Incorrecta";
                            message = "Número de tarjeta inválido, por favor verifica los datos de tu Tarjeta.";
                            swal2({
                                imageUrl: 'img/modalError.png',
                                imageClass: 'img-responsive img-error',
                                titleText: title,
                                text: message,
                                showConfirmButton: true,
                            });
                        } else if (valid === 'code') {
                            this.setState({
                                hideButtons: true,
                            });
                            title = "Oh no!";
                            message = "No hemos podido completar tu solicitudes., inténtalo de nuevo.";
                            swal2({
                                imageUrl: 'img/modalError.png',
                                imageClass: 'img-responsive img-error',
                                titleText: title,
                                text: message,
                                showConfirmButton: true,
                            });
                        } else if (valid === 'fraud') {
                            this.setState({
                                hideButtons: true,
                            });
                            title = "Oh no!";
                            message = "No hemos podido completar tu solicitudes, inténtalo de nuevo.";
                            swal2({
                                imageUrl: 'img/modalError.png',
                                imageClass: 'img-responsive img-error',
                                titleText: title,
                                text: message,
                                showConfirmButton: true,
                            });
                        }
                    } else {
                        let errorAPI = error.response.data.g2g;

                        if (errorAPI === 'CANCELADO' || errorAPI === 'NO_TIENE' || errorAPI === 'NO_ASIGNADA') {
                            title = "¡Producto no adquirido!";
                            message = "El número de Tarjeta ingresado no cuenta con el producto Tarjeta Digital Up Beneficios Bienestar, llama al 01 (55) 5814 9393 y ¡Adquiérelo ahora! <br/><br/>" +
                                "¡Aprovecha los beneficios que tenemos para ti!";

                            swal2({
                                imageUrl: 'img/modalError.png',
                                imageClass: 'img-responsive img-error',
                                titleText: title,
                                html: message,
                                showConfirmButton: true,
                            });
                        } else if (errorAPI === 'ADICIONAL') {
                            title = "Tarjeta Adicional";
                            message = "Número de Tarjeta Adicional, por favor ingresa el número de tarjeta del titular.";

                            swal2({
                                imageUrl: 'img/modalError.png',
                                imageClass: 'img-responsive img-error',
                                titleText: title,
                                text: message,
                                showConfirmButton: true,
                            });
                        }
                        else if (errorAPI === 'NA') {
                            title = "Oops...";
                            message = "El número de tarjeta no puede ser verificado en este momento, inténtalo de nuevo más tarde.";

                            swal2({
                                imageUrl: 'img/modalError.png',
                                imageClass: 'img-responsive img-error',
                                titleText: title,
                                text: message,
                                showConfirmButton: true,
                            });

                        } else if (errorAPI === 'INACTIVA') {
                            title = "¡Tarjeta inactiva!";
                            message = "El número de Tarjeta ingresado no está activado, llama al 01 (55) 5328 1087 y goza de este y más beneficios.";

                            swal2({
                                imageUrl: 'img/modalError.png',
                                imageClass: 'img-responsive img-error',
                                titleText: title,
                                text: message,
                                showConfirmButton: true,
                            });
                        } else {
                            title = "Oops...";
                            message = "En este momento no podemos validar tu Tarjeta, por favor inténtalo más tarde o llámanos al 01 (800) 704 6427.";

                            swal2({
                                imageUrl: 'img/modalError.png',
                                imageClass: 'img-responsive img-error',
                                titleText: title,
                                text: message,
                                showConfirmButton: true,
                            });
                        }
                    }
                });
        } else {
            $('#noTdc').val("");
            self.setState({
                tdcMasked: ""
            });

            let title = "Tarjeta Incorrecta";
            let message = "Número de tarjeta inválido, por favor verifica los datos de tu Tarjeta.";
            swal2({
                imageUrl: 'img/modalError.png',
                imageClass: 'img-responsive img-error',
                titleText: title,
                text: message,
                showConfirmButton: true,
            });
        }
    }

    onChange(response)
    {
        this.setState({
            captcha: response
        });
    }

    renderTdcModal() {
        let self = this;
        let inputStyle = {backgroundColor: "rgba(255,255,255,0.8)", fontSize: "23px"};

        return <div className="modal fade" tabIndex="-1" role="dialog" id="tdcModal">
            <div className="modal-dialog modal-mobile" role="document">
                <div className="modal-content" >
                    <div className="modal-body" style={{ textAlign: "justify" }}>
                        <div className="text-center" >
                            <img src={"img/headerAlert.png"} className="modal-image"/>
                            <br className="visible-lg" />
                            <br className="visible-lg" />
                            <div className="col-xs-8 col-xs-offset-2" style={{ marginTop: "5px" }}>
                                <img src={"img/imgModalHome.png"} className="img-modal-home"/>
                            </div>
                        </div>
                        <br className="visible-lg" />
                        <br className="visible-lg" />
                        <div className="col-xs-12" style={{ marginTop: "30px" }}>
                            <form onSubmit={this.requestTDC.bind(this)}>
                                <h5 className="h5-mobile" style={{ color: "#75716C !important"}}>A continuación, ingresa tu número de Tarjeta +Despensa o Tarjeta Digital DescluB: </h5>
                                <br/>
                                <MaskedInput mask={[/\d/, /\d/, /\d/, /\d/,'-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                                             id="noTdc" style={inputStyle} onChange={this.handleChange.bind(this)} type="password" inputMode="numeric" guide={false}
                                             className="form-control input-lg text-center"/>
                                <div className="col-md-12 text-center">
                                    {
                                        this.state.tdcMasked.length !== 0 &&
                                        <small>Tarjeta: {this.state.tdcMasked}</small>
                                    }
                                </div>
                                <br/>
                                <div className="row text-center">
                                    <small className="col-md-12 text-center">
                                        Para continuar, por favor completa el siguiente Captcha.
                                    </small>
                                    <div className="col-sm-12 col-lg-12">
                                        <ReCAPTCHA
                                            style={{ display: "inline-block" }}
                                            sitekey="6LeXIZQUAAAAAGg9Vkw_WrtqU1ZAgZDsPeP0KOKz"
                                            onChange={this.onChange}
                                        />
                                    </div>
                                    <div className="col-sm-6 col-sm-offset-3">
                                        <button type="submit" className="btn btn-block btn-mobile"
                                                style={{ borderRadius: "35px", backgroundColor: "#268EBF", color: "#FFFFFF" }}
                                                disabled={this.state.tdc.length !== 16 || this.state.captcha.length === 0}>
                                            Validar
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    renderModalCargando() {
        return <div className="modal fade" tabIndex="-1" role="dialog" id="modalCargando">
            <div className="modal-dialog" role="document">
                <div className="modal-content" >
                    <div className="modal-body">
                        <div className="text-center" >
                            <img src={"img/procesandoSolicitud.png"}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    renderModalError() {
        return <div className="modal fade" tabIndex="-1" role="dialog" id="modalError">
            <div className="modal-dialog" role="document">
                <div className="modal-content" >
                    <div className="modal-body">
                        <div className="text-center" >
                            <img src={"img/modalError.png"}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    render() {
        return (
            <div className="container-fluid">
                {
                    !this.state.hideButtons &&
                    this.renderTdcModal()
                }
                {this.renderModalCargando()}
                {this.renderModalError()}

                <div className="row horizontal-padding eq-height">
                    <div className="col-lg-6 p-l-60">
                        <section className="section-66 section-md-90">
                            <div className="sivale-logo">
                                <img src={"img/logoColor.png"}/>
                            </div>
                            {
                                !this.state.hideButtons &&
                                <div>
                                    <h4 className="sivale-title">
                                        Sólo por contar con el producto <br className="visible-xs" /> TARJETA DIGITAL UP BENEFICIOS BIENESTAR <br className="visible-xs" /> tenemos las mejores promociones para ti.
                                    </h4>
                                    <div className="text-center">
                                        <button className="button button-lg btn-promo" onClick={this.showModal.bind(this)}>
                                            <h4 className="btn-sivale-welcome" style={{ color: "#FFFFFF", textTransform: "uppercase" }}>Ver Promociones</h4>
                                        </button>
                                    </div>
                                </div>
                            }
                        </section>
                    </div>
                    <div className="col-lg-6" style={{backgroundImage: "url('img/sivale_home-01.png'", backgroundRepeat: "no-repeat", backgroundSize: "contain", backgroundPosition: "right center", paddingRight: 0}}>
                    </div>
                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }
}

export default CustomersWelcome;

if (document.getElementById('customers_welcome-component')) {
    ReactDOM.render(<CustomersWelcome/>, document.getElementById('customers_welcome-component'));
}


// WEBPACK FOOTER //
// ./resources/assets/react/CustomersWelcome.jsx